import React from 'react';

import ActionIconButton from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/cells/shared/ActionIconButton';
import useActivationActionsConfig from './useActivationActionsConfig';

export default function ActivationActions(integrationRow) {
  const { isUnmanagedIntegration, actionIconButtonProps, iconConfig } = useActivationActionsConfig(integrationRow);

  // Don't show action buttons if the integration is unmanaged
  if (isUnmanagedIntegration) {
    return null;
  }

  const { Icon, iconColor } = iconConfig;

  return (
    <ActionIconButton {...actionIconButtonProps}>
      <Icon color={iconColor} fontSize="medium" />
    </ActionIconButton>
  );
}
